// MVK-3312 — giá vé thấp nhất của suất chiếu, đọc từ booking-service
// (`POST /api/booking/v1/showtimes/prices`), thay `POST /showtime/price` (`ShowtimeController::price`)
// của chính moveek-web. Route PHP cũ vẫn sống tới hết soak — đường lui là revert MR này.
//
// Hợp đồng: body `{ showtimeIds: [uuid…] }` (tối đa 100 id), trả `{ prices: { <id>: số VND | null } }`.
// `null` = không có giá để hiện (suất không bán, upstream lỗi, mạch mở) — chip để trống.

export const SHOWTIME_PRICES_PATH = '/api/booking/v1/showtimes/prices';

// Trần của booking-service (`SHOWTIME_PRICES_MAX_IDS`): quá trần là 400 cho CẢ lô, nên tự chia.
export const SHOWTIME_PRICES_BATCH_SIZE = 100;

// Parity `ShowtimeController::getPrice()`: `round(price / 1000) . 'K'`. `Math.round` và `round()`
// của PHP chỉ khác nhau ở số âm, mà giá không âm.
export function formatShowtimePrice(minPrice) {
  if (typeof minPrice !== 'number' || !Number.isFinite(minPrice) || minPrice < 0) {
    return '';
  }

  return Math.round(minPrice / 1000) + 'K';
}

// Giá là trang trí: lô nào lỗi (mạng, 5xx, 400) thì lô đó coi như không có giá, các lô khác vẫn
// hiện — không bao giờ reject.
export function fetchShowtimePrices(showtimeIds, http) {
  const ids = Array.from(new Set(showtimeIds));
  const batches = [];

  for (let i = 0; i < ids.length; i += SHOWTIME_PRICES_BATCH_SIZE) {
    batches.push(ids.slice(i, i + SHOWTIME_PRICES_BATCH_SIZE));
  }

  return Promise.all(batches.map(function(batch) {
    return http.post(SHOWTIME_PRICES_PATH, { showtimeIds: batch })
      .then(function(response) {
        const prices = response && response.data ? response.data.prices : null;

        return prices && typeof prices === 'object' ? prices : {};
      })
      .catch(function() {
        return {};
      });
  })).then(function(results) {
    return Object.assign({}, ...results);
  });
}
